import { isNull } from "../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import Config from "../../../core/config/Config";
import NGTConfigKey from "../../base/NGTConfigKey";
import Scenario from "../Scenario";
/**
 * InitializeScenariosCommand.js
 * 
 * Created on Oct 17, 2013, 2:36:14 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class InitializeScenariosCommand {
    constructor(config, scenarioLibrary) {
        this._config = config;
        this._scenarioLibrary = scenarioLibrary;
    };

    execute(event) {
        this.initializeModel();
    };

    initializeModel() {
        var scenarios = this._config.getValue(NGTConfigKey.SCENARIOS);
        var defaultScenarioID;

        for (var i = 0; i < scenarios.length; i++) {
            var scenarioNode = scenarios[i];

            var scenario = new Scenario();
            scenario.id = scenarioNode.scenarioID;
            scenario.name = scenarioNode.name;
            scenario.storyID = scenarioNode.storyID;

            if (scenarioNode.hasOwnProperty("autoStart") && scenarioNode.autoStart) {
                defaultScenarioID = scenarioNode.scenarioID;
            }

            this._scenarioLibrary.addScenario(scenario);
            if (!isNull(defaultScenarioID) && scenario.id === defaultScenarioID) {
                this._scenarioLibrary.setDefaultScenario(scenario);
            }

            //fill the problemModel for this scenario
            // TODO: rewrite to JSON-based.

            /*var problemModel = new ranj.ProblemModel();
            var problems = scenarioNode.getElementsByTagName('problem');
            for(i = 0; i < problems.length; i++) {
                var problemNode = problems[i];
                var problem = new ranj.Problem();
                problem.setID(problemNode.getAttribute('id'));
                problem.setDescription(problemNode.getAttribute('description'));

                var arguments = problemNode.getElementsByTagName('argument');
                for(var i2 = 0; i2 < arguments.length; i2++) {
                    var argumentNode = arguments[i2];
                    var argument = new ranj.Argument();
                    argument.setID(argumentNode.getAttribute('id'));
                    argument.setDescription(argumentNode.getAttribute('description'));
                    problemModel.addPossibleArgument(argument);
                }

                var solutions = problemNode.getElementsByTagName('solution');
                for(i2 = 0; i2 < solutions.length; i2++) {
                    var solutionNode = solutions[i2];
                    var solution = new ranj.Solution();
                    solution.setID(solutionNode.getAttribute('id'));
                    solution.setDescription(solutionNode.getAttribute('description'));
                    
                    var supportingArguments = solutionNode.getElementsByTagName('supportingArgument');
                    for(var i3 = 0; i3 < supportingArguments.length; i3++) {
                        var argumentID = supportingArguments[i3].getAttribute('id');
                        solution.addArgument(problemModel.getPossibleArgumentByID(argumentID));
                    }
                    
                    var feedback = solutionNode.getElementsByTagName('feedback');
                    solution.setFeedbackDescription(feedback[0].getAttribute('description'));
                    solution.setFeedbackLabel(feedback[0].getAttribute('label'));
                    solution.isCorrect = feedback[0].getAttribute('correct') === 'true';
                    problem.addSolution(solution);
                }

                problemModel.addProblem(problem);
            }

            scenario.problemModel = problemModel;*/

        }

    };
}